import { formatMoney } from '@belong/common';
import { IconBranch } from '@belong/icons';
import { Button, Text } from '@belong/ui';
import { useFastMaintenanceSettings } from 'hooks/useFastMaintenanceSettings';
import { formatString } from 'strings';
import { ACCOUNTS_EARNINGS } from 'strings/accounts/earnings';

type SplitPaymentsBannerProps = {
  navigateToSplitPayments: () => void;
  withPlanItButton?: boolean;
  maxCashBack?: number;
  handleBillsPayment?: () => void;
  message?: string | undefined;
  showPayButton?: boolean;
  showAutoSplitLabel?: boolean;
};

export function SplitPaymentsBanner({
  navigateToSplitPayments,
  withPlanItButton = true,
  maxCashBack = 0,
  handleBillsPayment: _handleBillsPayment,
  message,
  showPayButton: _showPayButton = false,
  showAutoSplitLabel = false,
}: SplitPaymentsBannerProps) {
  const { isEnabled: _isEnabled } = useFastMaintenanceSettings();

  return (
    <div className="splitBanner my-sm flex w-full flex-col md:flex-row">
      <div className="flex w-full items-center">
        <div className="mr-2sm flex items-center rounded-full bg-lighter-green p-xs">
          <IconBranch height={14} className="text-green" />
          <Text
            variant="p1"
            fontWeight="semibold"
            className="ml-2xs whitespace-nowrap text-dark-green"
          >
            {`${ACCOUNTS_EARNINGS['section.split.action']} ···`}
          </Text>
        </div>
        <div>
          {maxCashBack === 0 ? (
            <>
              {showAutoSplitLabel ? (
                <>
                  <Text variant="body" className="mr-sm text-p1 md:text-body">
                    {formatString(ACCOUNTS_EARNINGS['section.split.auto'])}
                  </Text>
                </>
              ) : (
                <>
                  <Text variant="body" className="mr-sm text-p1 md:text-body">
                    {formatString(ACCOUNTS_EARNINGS['section.split.zero'])}
                  </Text>
                </>
              )}
            </>
          ) : (
            <>
              {showAutoSplitLabel ? (
                <>
                  <Text variant="body" className="mr-sm text-p1 md:text-body">
                    {formatString(ACCOUNTS_EARNINGS['section.split.auto'])}
                  </Text>
                </>
              ) : (
                <>
                  <Text variant="body" className="mr-sm text-p1 md:text-body">
                    {formatString(
                      ACCOUNTS_EARNINGS['section.split.title'](
                        formatMoney(maxCashBack, 'DOLLARS_NO_CENTS'),
                      ),
                    )}{' '}
                    {formatString(
                      ACCOUNTS_EARNINGS['section.split.subtitle'](),
                    )}
                  </Text>
                </>
              )}
            </>
          )}
        </div>
      </div>
      {withPlanItButton && (
        <div>
          {/* {isEnabled && (
            <>
              <div className="flex justify-end mt-lg md:mt-0">
                <Button size="small" variant="outline" buttonType="primary" onClick={navigateToSplitPayments}>
                  <div className="flex items-center">
                    <Text variant="body" fontWeight="semibold" className="mr-xs">
                      {ACCOUNTS_EARNINGS['section.split.action']}
                    </Text>
                  </div>
                </Button>
                {showPayButton && (
                  <div className="ml-2sm ">
                    <Button size="small" variant="solid" buttonType="primary" onClick={handleBillsPayment}>
                      <div className="flex items-center">
                        <Text variant="body" fontWeight="semibold" className="mr-xs">
                          {ACCOUNTS_EARNINGS['section.split.actionPay']}
                        </Text>
                      </div>
                    </Button>
                  </div>
                )}
              </div>
            </>
          )}
          {!isEnabled && (
            <>
              <div className="flex justify-end mt-lg md:mt-0">
                <Button variant="solid" buttonType="primary" onClick={navigateToSplitPayments}>
                  <div className="flex items-center">
                    <Text variant="body" fontWeight="semibold" className="mr-xs">
                      {ACCOUNTS_EARNINGS['section.split.action']}
                    </Text>
                  </div>
                </Button>
              </div>
            </>
          )} */}
          <div className="mt-lg flex justify-end md:mt-0">
            <Button
              variant="solid"
              buttonType="primary"
              onClick={navigateToSplitPayments}
            >
              <div className="flex items-center">
                <Text variant="body" fontWeight="semibold" className="mr-xs">
                  {ACCOUNTS_EARNINGS['section.split.action']}
                </Text>
              </div>
            </Button>
          </div>

          {typeof message !== 'undefined' ? (
            <p className="mt-xs">{message}</p>
          ) : null}
        </div>
      )}
    </div>
  );
}
